import { render, staticRenderFns } from "./RelationsEdit.vue?vue&type=template&id=03697de8&"
import script from "./RelationsEdit.vue?vue&type=script&lang=js&"
export * from "./RelationsEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports